// @flow strict
import * as actions from '../actions';
import type { Image, Link, Content } from '../types';

export type Partner = {
  id: number,
  slug: string,
  title: Content,
  content: Content,
  acf: {
    brochure: Image,
    contactLink: Link,
    partnerLogo: Image,
    websiteLink: Link,
  },
  type: 'partners',
  channel: Array<number>,
};

export type Channel = {
  id: number,
  count: number,
  name: string,
  slug: string,
  acf: {
    channelIcon: Image,
    topLevel: boolean,
  },
};

export type PartnerState = {
  +isFetching: boolean,
  +items: Array<Partner>,
  +channels: Array<Channel>,
};

export type RequestPartnersAction = {
  type: typeof actions.REQUEST_PARTNERS,
};

export type ReceivePartnersAction = {
  type: typeof actions.RECEIVE_PARTNERS,
  partners: Array<Partner>,
};

export type RequestChannelsAction = {
  type: typeof actions.REQUEST_CHANNELS,
};

export type ReceiveChannelsAction = {
  type: typeof actions.RECEIVE_CHANNELS,
  channels: Array<Channel>,
};

export type PartnersActions =
  | RequestPartnersAction
  | ReceivePartnersAction
  | RequestChannelsAction
  | ReceiveChannelsAction;
